import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { ApiService } from './api/api.service';


@Component({
  selector: 'app-purchase',
  templateUrl: './purchase.component.html',
  styleUrls: ['./purchase.component.css']
})
export class PurchaseComponent implements OnInit {

  constructor(public ApiService: ApiService,private titleService: Title) { }

  msearch : string;
  customer:any;
  products:any = [];
  infocalculate:any = [];
  summary : any = {customer:{},product:{}};

  productselected:number = null;
  productcode:string;
  anyproductselected:any = [];
  customerselected:number = null;
  customercode:string;
  successConfirm = false;

  detailcalculate:any = {"status":true,"data":{"status":"Success","message":{"totalAmount":505000,"prevbalance":502850,"vat":50500,"adminFee":7500,"stamp":0,"subTotal":1065850,"terbilang":" SATU JUTA ENAM PULUH LIMA RIBU DELAPAN RATUS LIMA PULUH RUPIAH.","detailService":[{"id":2139,"servicename":"LIfeStyle-licious","price":45000,"categoryid":3},{"id":2149,"servicename":"Soccer Mania 3 bulan","price":189545,"categoryid":15},{"id":2167,"servicename":"NHK World Premium 6 bulan","price":270455,"categoryid":15}],"id_trx_selfcare":"1696"}},"totalcount":null};

  detailservice : any;
  sumcalculate : any;
  iscalculate = false;

  /*showproducts : any = {"status":true,"data":[{"id":"2135","categoryid":"3","period":"0","servicename":"Asian Movie Lovers","price":"54091","provisioningcode":"ASIANMOVIES"},{"id":"2171","categoryid":"15","period":"12","servicename":"Asian Movie Lovers 12 bulan","price":"486818","provisioningcode":"ASIANMOVIES"},{"id":"2147","categoryid":"15","period":"3","servicename":"Asian Movie Lovers 3 bulan","price":"162273","provisioningcode":"ASIANMOVIES"},{"id":"2159","categoryid":"15","period":"6","servicename":"Asian Movie Lovers 6 bulan","price":"270455","provisioningcode":"ASIANMOVIES"},{"id":"2142","categoryid":"3","period":"0","servicename":"Cinema World","price":"18000","provisioningcode":"CINEMAWORLDHD"},{"id":"2178","categoryid":"15","period":"12","servicename":"Cinema World 12 bulan","price":"162000","provisioningcode":"CINEMAWORLDHD"},{"id":"2154","categoryid":"15","period":"3","servicename":"Cinema World 3 bulan","price":"54000","provisioningcode":"CINEMAWORLDHD"},{"id":"2166","categoryid":"15","period":"6","servicename":"Cinema World 6 bulan","price":"90000","provisioningcode":"CINEMAWORLDHD"},{"id":"2138","categoryid":"3","period":"0","servicename":"Entertainment","price":"45000","provisioningcode":"ENTPACK"},{"id":"2174","categoryid":"15","period":"12","servicename":"Entertainment 12 bulan","price":"405000","provisioningcode":"ENTPACK"},{"id":"2150","categoryid":"15","period":"3","servicename":"Entertainment 3 bulan","price":"135000","provisioningcode":"ENTPACK"},{"id":"2162","categoryid":"15","period":"6","servicename":"Entertainment 6 bulan","price":"225000","provisioningcode":"ENTPACK"},{"id":"2132","categoryid":"3","period":"0","servicename":"Happy Kids","price":"54091","provisioningcode":"KIDSPACK"},{"id":"2168","categoryid":"15","period":"12","servicename":"Happy Kids 12 bulan","price":"486818","provisioningcode":"KIDSPACK"},{"id":"2144","categoryid":"15","period":"3","servicename":"Happy Kids 3 bulan","price":"162273","provisioningcode":"KIDSPACK"},{"id":"2156","categoryid":"15","period":"6","servicename":"Happy Kids 6 bulan","price":"270455","provisioningcode":"KIDSPACK"},{"id":"2133","categoryid":"3","period":"0","servicename":"HBO Freak","price":"63182","provisioningcode":"HBOPACK"},{"id":"2169","categoryid":"15","period":"12","servicename":"HBO Freak 12 bulan","price":"568636","provisioningcode":"HBOPACK"},{"id":"2145","categoryid":"15","period":"3","servicename":"HBO Freak 3 bulan","price":"189545","provisioningcode":"HBOPACK"},{"id":"2157","categoryid":"15","period":"6","servicename":"HBO Freak 6 bulan","price":"315909","provisioningcode":"HBOPACK"},{"id":"2141","categoryid":"3","period":"0","servicename":"India Spot","price":"90455","provisioningcode":"India1"},{"id":"2177","categoryid":"15","period":"12","servicename":"India Spot 12 bulan","price":"814091","provisioningcode":"India1"},{"id":"2153","categoryid":"15","period":"3","servicename":"India Spot 3 bulan","price":"271364","provisioningcode":"India1"},{"id":"2165","categoryid":"15","period":"6","servicename":"India Spot 6 bulan","price":"452273","provisioningcode":"India1"},{"id":"2139","categoryid":"3","period":"0","servicename":"LIfeStyle-licious","price":"45000","provisioningcode":"LIFESTYPACK"},{"id":"2175","categoryid":"15","period":"12","servicename":"LifeSty-lelicious 12 bulan","price":"405000","provisioningcode":"LIFESTYPACK"},{"id":"2151","categoryid":"15","period":"3","servicename":"LifeStyle-licious 3 bulan","price":"135000","provisioningcode":"LIFESTYPACK"},{"id":"2163","categoryid":"15","period":"6","servicename":"LifeSty-lelicious 6 bulan","price":"225000","provisioningcode":"LIFESTYPACK"},{"id":"2143","categoryid":"3","period":"0","servicename":"NHK World Premium","price":"54091","provisioningcode":"NHK"},{"id":"2179","categoryid":"15","period":"12","servicename":"NHK World Premium 12 bulan","price":"486818","provisioningcode":"NHK"},{"id":"2155","categoryid":"15","period":"3","servicename":"NHK World Premium 3 bulan","price":"162273","provisioningcode":"NHK"},{"id":"2167","categoryid":"15","period":"6","servicename":"NHK World Premium 6 bulan","price":"270455","provisioningcode":"NHK"},{"id":"2137","categoryid":"3","period":"0","servicename":"Soccer Mania","price":"63182","provisioningcode":"BEINPACK"},{"id":"2173","categoryid":"15","period":"12","servicename":"Soccer Mania 12 bulan","price":"568636","provisioningcode":"BEINPACK"},{"id":"2149","categoryid":"15","period":"3","servicename":"Soccer Mania 3 bulan","price":"189545","provisioningcode":"BEINPACK"},{"id":"2161","categoryid":"15","period":"6","servicename":"Soccer Mania 6 bulan","price":"315909","provisioningcode":"BEINPACK"}],"account_id":{"account_id":1000234753}};
  */
  
  showproducts : any;


  error = false;
  result = false;
  formOpen = false;
  errMsg : string;

  loadingbuy = false;
  loadingbill = false;
  buttonbuydisable = true;
  radioService : number;
  CheckService : any = [];
  CheckServices : any = [];
  radioCustomer : number;

  shortproduct : any = [];
  
  keepproduct : any = [];
  groupprov : any = [];

  ngOnInit() {
    this.titleService.setTitle('Purchase Service');
    
  }

  search()
  {
    //alert(this.msearch);
    this.searchCustomer();
    //this.searchQueryParams = this.queryParams+'&search='+params;

    /*this.loadSearch({search:this.msearch});
    this.customerselected = null;
    this.productselected = null;
    this.summary = {customer:{},product:{}};
    this.radioCustomer = null;
    this.radioService = null;
    */
    
  }

  searchCustomer()
  {
    this.ApiService.searchCustomer({customerid: this.msearch }).subscribe((output:any) => {
        console.log(output);
        console.log(output.status);
        if ( output.status ){
          this.customer = output.data;
          console.log(this.customer);
          this.error = false;
          this.formOpen = true;
          this.loadProd();
        }else{
         this.error = true;
         this.formOpen = false;
         this.errMsg = output.message;
        }
       
      });
  }

  loadProd()
  {
    //console.log(this.customer);
    //console.log(this.customer[0].mainservice.serviceid);
    this.CheckService = [];
    this.products = [];
    this.CheckService = [];
    this.anyproductselected = [];
    this.summary.product = this.CheckService;

   // this.ApiService.getAlacarte({serviceid:this.customer[0].mainservice.serviceid}).subscribe((output:any) => {

    this.ApiService.getAlacarte({account_id:this.customer[0].customerid}).subscribe((output:any) => {
      console.log(output);
      if ( output.status ){
        if ( output.data['code'] == undefined ) {
          
          this.products = output.data;
          
          for (var val of this.products) {
      
            //console.log(val); // prints values: 10, 20, 30, 40

            let cat = val.categoryid.toString()+'cat';
            let idprod = val.id.toString()+'prod';

            if (this.keepproduct[val.provisioningcode] == undefined){
              this.keepproduct[val.provisioningcode] = [];
              this.groupprov.push(val.provisioningcode);
            }

            this.keepproduct[val.provisioningcode].push(val);
            
            this.shortproduct.push(val);
            
          }

        } else {
          alert(output.data['message']);
          this.error = true;
        }
        
        //this.error = false;
        //this.result = true;
      }else{
       //this.error = true;
       //this.result = false;
       //this.errMsg = output.message;
      }
       
    });
  }

  pickproduct(i)
  {
    this.productselected = i;
    console.log(i);
    console.log(i,this.isChecked(i));
    //console.log(this.products[i]);

    if ( this.isChecked(i) ){
      let y = this.CheckServices.findIndex(x => x.id === i);
      console.log(this.CheckService);
      this.CheckServices.splice(y, 1);
      this.anyproductselected.splice(y, 1);
      this.summary.product = this.CheckServices;
    }else{

      let tp = this.shortproduct.find(x => x.id === i);
      let y = this.CheckServices.findIndex(x => x.provisioningcode === tp.provisioningcode);
     
      if (y != -1 ){
        this.CheckServices.splice(y,1);
        this.anyproductselected.splice(y,1);
      }

     
      this.CheckServices.push(tp);

      this.summary.product = this.CheckServices;
      this.anyproductselected.push(tp);
      if ( this.customerselected != null && this.productselected != null ){
        this.buttonbuydisable = false;
      }
    }

    console.log(this.CheckServices);
    console.log(this.summary.product);
    console.log(this.anyproductselected);


  }

  ada(items)
  {
    if (items == undefined){
      return false;
    } else{
      return true;
    }
  }

  selected(i)
  {
    if (i == this.productselected){
      return 'list-group-item-action list-group-item-primary';
    }else{
      return '';
    }
  }

  pickcustomer(i)
  {
    
    //console.log(i);
    //console.log(this.customer[i]);  
    if ( this.customer[i]['is_isp'] == 1 ){
      
      alert('Anda tidak dapat memilih ID Pelanggan ini');

    }else{
      this.customerselected = i;
      this.radioCustomer = this.customer[i]['customerid'];
      this.summary.customer = this.customer[i];
      if ( this.customerselected != null && this.productselected != null ){
        this.buttonbuydisable = false;
      }
    }
  }

  selectedcustomer(i)
  {
    if (i == this.customerselected){
      return 'list-group-item-action list-group-item-success';
    }else{
      return '';
    }
  }

 
  
  buydisabled()
  {
    return (!this.isCustomerSelected() || !this.isProductSelected());
    //return  this.buttonbuydisable;
  }




  calculate()
  {
      let ls = '';
      console.log(ls);
      console.log( this.anyproductselected);
      for (let num of this.anyproductselected) {
        console.log(num);

        if ( num.id != undefined ){
          if ( ls == '' ){
            ls = ls + num.id;
          }else{
            ls = ls + ',' +num.id;
          }
        }

      }
      console.log(ls);

      let param = {
                "account_id": this.radioCustomer,
                "list_service" : ls
      };


      console.log(param);
      this.ApiService.Calculate(param).subscribe((output:any) => {
      console.log(output);
      if ( output.status ){
        this.detailcalculate = output.data;
        this.sumcalculate = this.detailcalculate.message;
        this.iscalculate = true;
        //this.error = false;
        //this.result = true;
      }else{
       //this.error = true;
       //this.result = false;
       //this.errMsg = output.message;
      }
       
    });
  }
  
  buy()
  {
  
    this.loadingbuy = true;
    this.buttonbuydisable = true;
    // checkout
    let selected = this.products[this.productselected];
    let mycustomer = this.customer[this.customerselected];
    this.summary = {customer:mycustomer,product:selected};
    let data = {"ID":selected['productcode'],"CID":mycustomer['customerid']};
    console.log(data);
    console.log(this.summary);
/*
    setTimeout(() => {  
        this.successConfirm = true;
        this.formOpen = false; }, 
    2000);

    return;
*/

    /*return this.partnerService.PostWPCheckout(data).subscribe((output: any) => {
      console.log(output);
      if ( output.status ){
        //window.location.href = 'https://b2b-api.mncplay.id/billmain.php?CID='+mycustomer['customerid'];
        //this.successConfirm = true;
        //this.formOpen = false;

        let params = {customer_id:output.data['account_id'],paketname:output.data['paketname'],sn:output.data['sn'],price:output.data['price'], nohp:output.data['nohp']};

        this.WaNotif(params);

      }else{
       this.successConfirm = false; 
       alert(output.data.message);

       this.loadingbuy = false;
       this.buttonbuydisable = false;
       //this.error = true;
       //this.result = false;
       //this.errMsg = output.message;
      }
    })*/
  }

  onSubmit()
  {
    var data = new FormData();
  data.append("app_id", "ATV");
  data.append("localdatetime", "20200411204100");
  data.append("product_id", "50100");
  data.append("customer_id", "1000000665");
  data.append("signature", "4849d1ec62a4d0891bae574e4dd9ef0250d12752");

  var xhr = new XMLHttpRequest();
  xhr.withCredentials = true;

  xhr.addEventListener("readystatechange", function () {
    if (this.readyState === 4) {
      console.log(this.responseText);
    }
  });

  xhr.open("POST", "https://billing.mncplay.id/main/billinfo");
  xhr.setRequestHeader("Content-Type", "application/xhtml+xml");
  xhr.setRequestHeader("cache-control", "no-cache");
  xhr.setRequestHeader("Postman-Token", "16256e72-69a2-4e0e-b78c-d42969ed3283");

  xhr.send(data);
  }

  isCustomerSelected(){
    if ( this.customerselected == null ){
      return false;
    }else{
      return true;
    }
  }

  isProductSelected(){
    if ( this.productselected == null ){
      return false;
    }else{
      return true;
    }
  }

  isChecked(i){
    if ( this.CheckServices.findIndex(x => x.id === i) == -1 ){
      //this.CheckService[i] = 0;
      return false;
    } else {
      return true;
    }
  }

  nextBill()
  {
    this.loadingbill = true;
    window.location.href = 'https://b2b-api.mncplay.id/billmain.php?CID='+this.summary.customer.customerid;
  }

  WaNotif(params)
  {
    /*return this.partnerService.PostWPWaNotif(params).subscribe((output: any) => {
      console.log(output);
      this.successConfirm = true;
        this.formOpen = false;
    },error=>{
      //alert('error');
      this.successConfirm = true;
        this.formOpen = false;
    });*/

  }
 
}


